import { render, staticRenderFns } from "./PriceTemplates.vue?vue&type=template&id=201a0fce"
import script from "./PriceTemplates.vue?vue&type=script&lang=ts"
export * from "./PriceTemplates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports